// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".roster-dot {\n  display: flex;\n}\n.roster-dot-item {\n  height: 10px;\n  width: 10px;\n  background-color: #bbb;\n  border-radius: 50%;\n  display: inline-block;\n}\n.roster-dot-text {\n  margin: 0 16px 0 6px;\n}", ""]);
// Exports
module.exports = exports;
